import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Joyride from 'react-joyride';
import { getPageTourSteps, getTourPath, tourStyles } from 'config/tourConfig';
import { useTour } from 'contexts/TourContext';

const PAGE_TOURS_KEY = 'show_page_tours';

export default function PageTour() {
  const { pathname } = useLocation();
  const { request, clearRequest } = useTour();
  const [run, setRun] = useState(false);

  const effectivePathname = useMemo(() => getTourPath(pathname), [pathname]);

  const steps = useMemo(
    () => getPageTourSteps(effectivePathname).map((step) => ({ ...step, disableBeacon: true })),
    [effectivePathname]
  );

  // Trigger tour when the user clicks "Start Tour" from the help dialog
  useEffect(() => {
    if (!steps.length) return;
    if (request?.pathname === pathname) {
      setRun(true);
    }
  }, [request, pathname, steps.length]);

  // Auto-trigger after the side menu nav tour has finished
  useEffect(() => {
    if (!steps.length) return;
    if (request?.pathname === pathname) return; // manual request handles this
    if (effectivePathname === '/' || effectivePathname === '/default') return;
    if (localStorage.getItem(PAGE_TOURS_KEY) !== 'true') return;
    if (localStorage.getItem(`page_tour_seen_${effectivePathname}`) === 'true') return;

    const timer = setTimeout(() => setRun(true), 600);
    return () => clearTimeout(timer);
  }, [effectivePathname, steps.length, request?.pathname]);

  const handleCallback = (data) => {
    if (data.status === 'finished' || data.status === 'skipped') {
      setRun(false);
      localStorage.setItem(`page_tour_seen_${effectivePathname}`, 'true');
      clearRequest();
    }
  };

  if (!steps.length) return null;

  return (
    <Joyride
      run={run}
      steps={steps}
      continuous={false}
      showSkipButton
      scrollToFirstStep
      scrollOffset={120}
      callback={handleCallback}
      styles={tourStyles}
    />
  );
}
